import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { ContractsKpiCfg, ContractsKpiCfgService } from "./contractsKpiCfg.service";
import { ContractsKpiService, Range } from "./contractsKpiService";
import { DateRange } from "./dateRange";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class ContractDetail {
    public unitId: string;
    public unitName: string;
    public nif: string;
    public name: string;
    public beginDate: Date;
    public endDate: Date;
    public laboralContractId: string;
    public workerId: number;
    public workername: string;
    public workerEmail: string;
    public workerPhone: string;
    public clientFiscalName: string;
    public clientPhone: string;
    public contactName: string;
    public contactPhone: string;
    public nameLastJob: string;
}

export class ExpiringContractsDetailServiceData {
    public contracts: ContractDetail[];
    public updateTimestamp: Date;

}

export abstract class ExpiringContractsDetailService extends ContractsKpiService<ExpiringContractsDetailServiceData> {
    protected abstract getRange(): DateRange;
    constructor(private serviceCfg: ContractsKpiCfgService, private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService, private httpClient: HttpClient, injector: Injector) {
        super(injector);
    }

    protected getDates(): Range {
        return this.getDateRange(DateRange.Inmediate);
    }

    protected async update(): Promise<ExpiringContractsDetailServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: ExpiringContractsDetailServiceData = null;
            try {
                let cfg: ContractsKpiCfg = this.serviceCfg.getCfg();

                let { begin, end } = this.getDateRange(this.getRange());
                let url = cfg.expiringContracts.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.get<ExpiringContractsDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}

@Injectable()
export class PastExpiringContractsDetailService extends ExpiringContractsDetailService {
    public getClassName() { return "PastExpiringContractsDetailService"; }

    constructor(serviceCfg: ContractsKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange() { return DateRange.Past; }
}

@Injectable()
export class InmediateExpiringContractsDetailService extends ExpiringContractsDetailService {
    public getClassName() { return "InmediateExpiringContractsDetailService"; }

    constructor(serviceCfg: ContractsKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange() { return DateRange.Forecast; }
}

@Injectable()
export class ForecastedExpiringContractsDetailService extends ExpiringContractsDetailService {
    public getClassName() { return "ForecastedExpiringContractsDetailService"; }

    constructor(serviceCfg: ContractsKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange() { return DateRange.Forecast; }
}
